import { graphql } from "@opensea/graphql"

export const SwapDetailsMaxSlippageItemFragment = graphql(
  `
    fragment SwapDetailsMaxSlippageItem on SwapQuote {
      slippageTolerance
    }
  `,
  [],
)
